import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=25acb0fa&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=25acb0fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25acb0fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25acb0fa')) {
      api.createRecord('25acb0fa', component.options)
    } else {
      api.reload('25acb0fa', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=25acb0fa&scoped=true&", function () {
      api.rerender('25acb0fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2fnh8Ndvy0N7K/JS/comp/GuestBox.vue"
export default component.exports